module.exports = __webpack_public_path__ + "98aac9a8474370e56f489acc38052ce3.png";